import React, { Component } from "react";
import { Navbar, Nav } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import { connect } from "react-redux";


const mapStateToProps = state => {
	return {
		role: state.currentUserReducer.role,
        countyName: state.countyConfigCommonReducer.countyName,
		language: state.currentUserReducer.language ? state.currentUserReducer.language : 'ENGLISH'  
	};
}

class Navigationbar extends Component {
    render() {
        return <Navbar bg="light" expand="lg" style={{ padding: 2 }}>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto" style={{ width: '100%' }}>
                    <NavLink to="/home" className="top-navlink">User View</NavLink>
                    { 
                        this.props.role === 'TENANT' &&
                        <NavLink to="/tenantAdmin" className="top-navlink top-navlink">Admin</NavLink>
                    }
                    { 
                        (this.props.role === 'FOREVER' || this.props.role === 'TRIMIN' || this.props.role === 'COUNTY' ) &&
                        <NavLink to="/controlPanel" className="top-navlink top-navlink-last">Control Panel</NavLink>
                    }
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    }

}

export default connect(mapStateToProps)(Navigationbar);
